<template>
  <div class="demo-image">
    <div>测试下需求图片</div>
    <div class="block" v-for="fit in fits" :key="fit">
      <span class="demonstration">{{ fit }}</span>
      <el-image style="width: 100px; height: 100px" :src="url" :fit="fit"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "Demand",
  data() {
    return {
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      url:
        " https://files.jinshuju.net/en/RhMtBf/Fs7MangdTGFLEzXE5KESh6qYH5Ab_field_2_1586923728.png?token=7NK_Z1IEoKaIY6I9RXzO4b9uQPwuwdvnlGbzHZmF:s8_CvqA-8wK0r3RGiKVegpYu3t0=:eyJTIjoiZmlsZXMuamluc2h1anUubmV0L2VuL1JoTXRCZi9GczdNYW5nZFRHRkxFelhFNUtFU2g2cVlINUFiX2ZpZWxkXzJfMTU4NjkyMzcyOC5wbmcqIiwiRSI6MTkwMjQ5NDA4NH0=&download&attname=序号3_2_1_slogn的副本3.png"
    };
  }
};
</script>

<style>
</style>

